export class ConnectionTestState {
  connectionSuccesful = false
  errorMessage = undefined
}
